module.exports = __webpack_public_path__ + "media/images/favicon-00adb713bd8f51337b402237581aa6dd.png";